<!--
 * @Author: wang peng
 * @Date: 2023-2-28
 * @Description: 订单管理-历史订单-订单详情
-->
<template>
  <scroll-layout>
    <template slot="header">
      <div v-if="pageButtons.length > 0" class="button-wrap">
        <template v-for="(button, index) in pageButtons">
          <ykc-button
            :key="index"
            v-if="button.enabled"
            v-bind="button"
            @click="button.handleClick(button, $event)">
            {{ button.text }}
          </ykc-button>
        </template>
      </div>
    </template>
    <div class="real-time-detail">
      <!-- 用户支付信息/订单 start -->
      <div class="flexConent">
        <ykc-detail
          :isLine="true"
          :tips="tips"
          :titles="[`订单号：${dealData(detailData.tradeSeq)}`]"
          :className="'left'">
          <div slot="cvBody">
            <div class="form-detail flex">
              <ykc-form :label-position="'left'" label-width="130px" class="list-left">
                <ykc-detail-item :label="'订单状态：'">
                  <span>{{ dealData(detailData.tradeStatusName) }}</span>
                </ykc-detail-item>
                <ykc-detail-item :label="'站品牌：'">
                  <span>{{ dealData(detailData.brandName) }}</span>
                </ykc-detail-item>
                <ykc-detail-item :label="'充电用户：'">
                  <span>{{ dealData(detailData.userAccount) }}</span>
                </ykc-detail-item>
                <ykc-detail-item :label="'充电站名称:'">
                  <span>{{ dealData(detailData.stationName) }}</span>
                </ykc-detail-item>
                <ykc-detail-item :label="'终端名称：'">
                  <span>{{ dealData(detailData.gunCode) }}</span>
                </ykc-detail-item>
                <ykc-detail-item :label="'终端ID：'">
                  <span>{{ dealData(detailData.gunId) }}</span>
                </ykc-detail-item>
                <ykc-detail-item :label="'订单结束原因：'">
                  <span>{{ dealData(detailData.stopChargeReasonName) }}</span>
                </ykc-detail-item>
              </ykc-form>
            </div>
          </div>
        </ykc-detail>
        <ykc-detail
          :isLine="true"
          :tips="tips"
          :titles="['用户支付信息']"
          class="table-body left"
          ref="headRight">
          <div slot="cvBody" class="bottom-content">
            <ykc-form :label-position="'left'" label-width="130px" class="list-left">
              <ykc-detail-item :label="'充电电量：'">
                <span>{{ dealData(detailData.chargedPowerOri) }} 度</span>
              </ykc-detail-item>
              <ykc-detail-item :label="'电费：'">
                <span>{{ dealData(detailData.chargedAmount) }} 元</span>
              </ykc-detail-item>
              <ykc-detail-item :label="'服务费：'">
                <span>{{ dealData(detailData.serviceAmount) }} 元</span>
              </ykc-detail-item>
              <ykc-detail-item :label="'订单总金额:'">
                <span>{{ dealData(detailData.totalAmount) }} 元</span>
              </ykc-detail-item>
              <ykc-detail-item :label="'用户实付：'">
                <span>{{ dealData(detailData.totalAmount) }} 元</span>
              </ykc-detail-item>
              <ykc-detail-item :label="'微信商户：'">
                <span>{{ dealData(detailData.mchName) }}</span>
              </ykc-detail-item>
              <ykc-detail-item :label="'结算时间：'">
                <span>{{ dealData(detailData.tradeTime) }}</span>
              </ykc-detail-item>
            </ykc-form>
          </div>
        </ykc-detail>
      </div>
      <!-- 用户支付信息/订单 end -->
      <!-- 充电明细 start -->
      <ykc-detail
        :tips="tips"
        :isLine="true"
        :titles="['充电明细']"
        class="table-body"
        ref="headLeft_three">
        <div slot="cvBody">
          <ykc-table :data="chargedDetail" :columns="tableColumns" v-if="chargedDetail.length != 0">
            <div slot="pagination" v-if="chargedDetail.length != 0">
              <div class="botton-table">
                <div class="sum_time">总计（总时长：{{ detailData.chargedTimeOri }}）</div>
                <div class="sum_chargedPower">{{ detailData.chargedPower }}</div>
                <div class="sum_orderAmountSeg">{{ detailData.totalAmount }}</div>
              </div>
            </div>
          </ykc-table>
          <div class="charge-empty" v-else>
            <img src="../../../assets/images/no-data.png" />
            <span>暂无数据</span>
          </div>
        </div>
      </ykc-detail>
      <!-- 充电明细 end -->
    </div>
    <share-chart
      v-if="detailData.startTime"
      :title="'状态监测'"
      :tradeNo="detailData.tradeSeq"
      :page="'historicalDetail'"
      :startTime="detailData.startTime"
      :endTime="detailData.endTime"></share-chart>
  </scroll-layout>
</template>

<script>
  import { localGetItem } from '@/utils';
  import { orderPage } from '@/service/apis';
  import shareChart from '../OrderShareChart2.vue';

  export default {
    name: 'historicalOrderDetail',
    components: {
      shareChart,
    },
    data() {
      return {
        tips: false,
        tradeSeq: '',
        gunCode: '',
        detailData: {},
        orderDetail: {},
        tags: [],
        recordPayList: [],
        chargedDetail: [],
        chargedTimeStr: [],
        chargedHourStr: [],
        titles: ['订单号', '118298292992'],
        tableColumns: [
          { label: '充电时段', prop: 'time' },
          // { label: '电价类型', prop: 'feeType' },
          { label: '电费单价(元/度)', prop: 'chargedPrice' },
          { label: '服务费单价(元/度)', prop: 'servicePrice' },
          { label: '充电度数(度)', prop: 'chargedPower' },
          { label: '费用(元)', prop: 'orderAmount' },
        ],
        isShare: false, // 是否是私桩共享订单
      };
    },
    computed: {
      pageButtons() {
        return [
          {
            text: '返回',
            type: 'plain',
            enabled: true,
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ];
      },
      payFun() {
        let str = '';
        const useType = localGetItem('dictionary')?.pay_type || [];
        useType.forEach(item => {
          if (item.code === this.detailData.payType) {
            str = item.name;
          }
        });
        return str;
      },
      stopChargeReasonType() {
        const typeData = localGetItem('dictionary')?.stop_charge_reason || [];
        const typeName =
          typeData.find(item => item.code === this.detailData.stopChargeReason)?.name ?? '——';
        return typeName;
      },
    },
    created() {
      this.recordId = this.$route.query.recordId;
      this.isShare = this.$route.path.includes('privatePileShare');
      // 迁桩后老订单显示老终端编码
      this.gunCode = this.$route.query.gunCode;
      console.log('this.$route', this.$route);
      this.getDetail();
    },
    methods: {
      /**
       * 获取详情数据
       */
      getDetail() {
        orderPage
          .thirdPartyChargingOrderInfo({ recordId: this.recordId })
          .then(res => {
            console.log('请求详情数据+++++', res);
            this.detailData = res;
            this.chargedDetail = res.chargeDetails || [];
            const cls = [
              { id: 1, name: '扫码启动' },
              { id: 2, name: '扫码启动' },
              { id: 3, name: '刷卡充电' },
              { id: 4, name: '即插即充' },
              { id: 5, name: '流量方' },
              { id: 6, name: '预约充电' },
              { id: 7, name: '离线卡' },
            ][Number(this.detailData?.chargingSource) - 1];

            // 结算方式
            const settleTypeMap = {
              0: '正常结算',
              1: '异常单手动结算',
              2: '异常单自动结算',
              3: '平台延迟结算',
              4: '三方延迟结算',
            };
            const settleType = settleTypeMap[this.detailData?.settleType] ?? '一';
            // 订单类型
            const orderTypeMap = {
              0: '直联订单',
              1: '流量订单',
              2: '桩联订单',
              3: '双向互联',
            };
            const orderType = orderTypeMap[this.detailData?.orderType] ?? '一';

            this.tags = [
              {
                type: 'tt2',
                name: `${cls?.name || '一'}`,
              },
              {
                type: 'tt2',
                name: `${settleType}`,
              },
              {
                type: 'tt2',
                name: `${orderType}`,
              },
            ];
            if (this.isShare) {
              this.tags.push({
                type: 'tt2',
                name: `私桩共享订单`,
              });
            }
          })
          .catch(err => {
            console.log('err123', err);
          });
      },
      /**
       *
       */
      dealData(value) {
        console.log('data+++', value);
        if (value !== undefined && value !== null && value !== '') {
          return value;
        }
        return '——';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .real-time-detail {
    .flexConent {
      margin-bottom: 16px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;

      .cardview-body {
        .bottom-content {
          .el-scrollbar__wrap {
            .el-scrollbar__view {
              .list {
                min-width: 200px !important;
              }
            }
          }
        }
      }
      .right-boxs {
        margin-left: 16px;
        flex: 1;

        .card-content {
          display: flex;
          padding-bottom: 10px;

          .card {
            width: 32%;
            height: 187px;
            margin-right: 20px;
            border: 1px solid #ebebf0;
            border-radius: 2px;
            overflow: hidden;
            position: relative;
            background: rgba(55, 115, 252, 0.1);

            .date {
              width: 152px;

              font-family: PingFangSC-Medium;
              font-size: 12px;
              color: #ffffff;
              letter-spacing: -0.17px;
              text-align: left;
              background: #3773fc;
              border-bottom-right-radius: 10px;
              padding: 1px 8px;
            }

            .time-content {
              letter-spacing: 0;
              text-align: center;
              margin-top: 56px;

              .time-num {
                font-size: 28px;
                color: #3773fc;

                .unit {
                  font-size: 14px;
                }
              }

              .time-title {
                font-size: 14px;
                color: #000000;
                margin-top: 18px;
              }
            }

            .time-content2 {
              letter-spacing: 0;
              text-align: center;
              margin-top: 56px;

              .time-num {
                font-size: 28px;
                color: #3773fc;

                .unit {
                  font-size: 14px;
                }
              }

              .time-title {
                font-size: 14px;
                color: #000000;
                margin-top: 18px;
              }
            }
          }

          .card:last-child {
            margin-right: 0;
          }
        }
        .cardview-box-content {
          width: calc(97.4%);
          margin-top: 16px;
        }
      }
    }

    .button-group {
      margin-bottom: 10px;

      .ykc-button {
        margin-left: 8px;
      }
    }

    .last-list {
      .el-form-item {
        margin-bottom: 0;
      }
    }

    .cardview-box {
      .cardview-head {
        margin-top: 0px;
        padding-left: 10px;

        .cardview-head-box {
          margin: 17px 0;
        }

        .cardview-body {
          margin: -10px;
        }
      }

      .table-body .cardview-body {
        padding: 0 0 20px 0;
        margin: 0 -10px;
      }
    }

    .ykc-icon-power:before,
    .ykc-icon-chargingTime:before,
    .ykc-icon-soc:before,
    .ykc-icon-chargingTime:before,
    .ykc-icon-charging-degree:before {
      position: absolute;
      bottom: 0;
      right: 0;
      font-size: 72px;
      color: rgb(55, 115, 252);
      opacity: 0.096;
    }
    .ykc-icon-amount:before {
      position: absolute;
      bottom: 0;
      right: -2px;
      font-size: 72px;
      color: rgb(55, 115, 252);
      opacity: 0.096;
    }
    .steps {
      width: 100%;
      display: flex;
      justify-content: space-around;
      padding-bottom: 10px;

      .card-wrap {
        text-align: center;

        .steps-card {
          margin: 0 10px;

          .card-item {
            min-width: 48px;
            font-size: 12px;
            padding: 4px 18px;
            color: #4d8cfd;
            letter-spacing: -0.17px;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            border: 1px solid;
            border-radius: 2px;
            font-weight: 600;

            &::after {
              content: '';
              background: #4d8cfd;
              width: 100%;
              height: 100%;
              opacity: 0.1;
              position: absolute;
              left: 0;
              top: 0;
            }
          }
        }

        .card-time {
          color: #4a4a4a;
          font-size: 12px;
          margin-top: 13px;
          font-weight: 600;
        }
      }

      .steps-line {
        width: 14%;
        margin: 11px 0px;
        background-color: inherit;
        height: 2px;
        background-image: linear-gradient(to right, #000000 0%, #000000 50%, transparent 0%);
        background-size: 5px 1px;
        background-repeat: repeat-x;
        border-width: 0;
        border-style: solid;
        border-color: inherit;
        transition: 0.15s ease-out;
        box-sizing: border-box;
      }
    }
    .list-item {
      border-bottom: 1px dashed #f1f0f0;
      box-sizing: border-box;
      padding: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .detail-left {
        .detail-title {
          font-size: 12px;
          display: flex;

          .tag {
            background: #fff2e0;
            color: #ff5521;
            font-size: 16px;
            transform: scale(0.5);
            padding: 1px 8px;
            transform-origin: left;
            margin-left: 10px;
            margin-top: -6px;
            .coupon {
              font-size: 22px;
            }
          }
        }

        .detail-tips {
          text-align: left;

          div {
            color: #9b9b9b;
            font-size: 12px;
            transform: scale(0.83);
            transform-origin: left;
            margin-top: 4px;
          }

          .blank {
            color: #000000;
            font-weight: 400;
          }

          .space {
            margin-left: 20px;
          }

          .blue {
            color: #4d8cfd;
            font-weight: 400;
          }
        }
      }

      .detail-right {
        .money {
          font-size: 12px;
          color: #000000;

          div {
            display: inline-block;

            p {
              margin: 0;
            }
          }

          .left-money {
            text-align: right;
            margin-right: 4px;
          }

          .right-money {
            color: #9b9b9b;
            text-align: left;
            margin-left: 4px;
          }
        }

        .totla {
          font-size: 14px;
          color: #000000;
          font-weight: 600;
        }

        .totla-blue {
          font-size: 14px;
          color: #4d8cfd;
          font-weight: 600;
        }
      }

      .emphasize {
        font-weight: 600;
      }
    }
    .charge-empty {
      margin: 0 auto;
      text-align: center;
      padding-bottom: 20px;

      display: flex;
      flex-flow: column nowrap;
      align-items: center;

      > img {
        width: 100px;
      }

      span {
        display: block;
        font-size: 12px;
        color: #88b0ff;
        text-align: center;
      }
    }
    .headLeft_one {
      margin: 16px 0;
    }

    .botton-table {
      display: table;
      width: 100%;
      font-size: 12px;
      font-weight: 700;
      color: #4d8cfd;
      .sum_time {
        display: table-cell;
        width: 60%;
        padding-left: 30px;
      }

      .sum_chargedPower {
        display: table-cell;
        width: 20%;
        padding-left: 8px;
      }

      .sum_orderAmountSeg {
        display: table-cell;
        width: 20%;
        padding-left: 8px;
      }
    }
  }
</style>
